import styled from "@emotion/styled";
export const StyledTagComponent = styled.div`
  font-size: 1.069rem;
  padding: 8px 16px;
`;
